"use client"

import NextLink from "next/link"
import type { ComponentProps } from "react"
import { normalizeBookingHref } from "@/modules/booking/channel-links"
import { BookingLink } from "./booking-link"

const nextOnlyProps = new Set(["href", "as", "replace", "scroll", "shallow", "prefetch", "locale", "onNavigate", "legacyBehavior", "passHref"])
export default function BookingAwareLink(props: ComponentProps<typeof NextLink>) {
  if (typeof props.href !== "string") return <NextLink {...props} />
  const target = normalizeBookingHref(props.href)
  if (target === props.href && !/^\/(?:en\/|es\/)?book(?:\/|\?|$)/.test(target)) return <NextLink {...props} />
  const anchorProps = Object.fromEntries(Object.entries(props).filter(([key]) => !nextOnlyProps.has(key))) as ComponentProps<"a">
  return <BookingLink {...anchorProps} href={target} />
}
